import React from 'react';
import Navigation from '../../components/navigation'
import {Link} from 'react-router-dom'

import arrow from './../../images/arrow_more_left.png'
import './index.css'


export default class index extends React.Component {
    state = {
        interviewPage:1
    }
    componentWillMount(){
        
    }
    interviewPageAdd=()=>{
        var index = this.state.interviewPage + 1;
        this.setState({interviewPage:index})  
    }
    interviewPageRemove=()=>{
        var index = this.state.interviewPage - 1;
        this.setState({interviewPage:index})
    }
    render(){
        return (
            <main>
                <Navigation tab="index"></Navigation>
                <div className="detail_title"> <Link to="/index">首页 / 精彩专访 /</Link> {this.props.match.params.id == 1 ? '刘倩' : ''}{this.props.match.params.id == 2 ? '谭雪' : ''}{this.props.match.params.id == 3 ? '林声' : ''}{this.props.match.params.id == 4 ? '孙伟' : ''}</div>
                <div className="interview_container">
                    <div className="left_inner">
                        {this.props.match.params.id == 1 &&
                            <div className="info"> 
                                <img src={require('./../../pic/interview23.jpg')} alt=""></img>
                                <p>专访人物 - 刘倩</p>
                                <p>国家击剑队健将级运动员</p>
                            </div>
                        }
                        {this.props.match.params.id == 2 &&
                            <div className="info"> 
                                <img src={require('./../../pic/interview11.jpg')} alt=""></img>
                                <p>专访人物 - 谭雪</p>
                                <p>女子击剑运动员</p>
                                <p>生日：1984年1月30日</p>
                                <p>出生于天津</p>
                            </div>
                        }
                        {this.props.match.params.id == 3 &&
                            <div className="info"> 
                                <img src={require('./../../pic/interview01.jpg')} alt=""></img>
                                <p>专访人物 - 林声</p>
                                <p>中国击剑运动员</p>
                                <p>出生在福州盖山</p>
                            </div>
                        }
                        {this.props.match.params.id == 4 &&
                            <div className="info"> 
                                <img src={require('./../../pic/interview31.jpeg')} alt=""></img>
                                <p>专访人物 - 孙伟</p>
                                <p>中国击剑队男子佩剑运动员</p>
                                <p>生日：1992年10月27日</p>
                                <p>出生于江苏徐州</p>
                            </div>
                        }
                        <div className="other">
                            <div className="layout">
                                <div>
                                    <span>精彩专访</span>
                                    <div>
                                        {this.state.interviewPage < 3 &&
                                            <img src={arrow} alt="" onClick={this.interviewPageAdd.bind(this)} className="add"></img>   
                                        }
                                        </div>
                                    <span style={{float:'right',marginTop:'.16rem'}}>{this.state.interviewPage}/<b style={{fontWeight:400,color:this.state.interviewPage < 3 ? '#999999' : '#333333'}}>3</b></span>
                                    <div>
                                        {this.state.interviewPage > 1 &&
                                            <img src={arrow} alt="" onClick={this.interviewPageRemove.bind(this)} className="remove"></img> 
                                        }
                                    </div>  
                                </div>
                            </div>
                            {this.props.match.params.id == 1 &&    
                                <div className="other_interview">
                                    {this.state.interviewPage === 1 &&
                                    <Link to="/interview/2">
                                        <div>
                                            <img src={require('./../../pic/interview11_s.jpg')} alt=""></img>
                                            <p><b>谭雪</b>女子击剑运动员</p>
                                        </div>
                                    </Link>
                                    }
                                    {this.state.interviewPage === 2 &&
                                    <Link to="/interview/3">
                                        <div>
                                            <img src={require('./../../pic/interview01_s.jpg')} alt=""></img>
                                            <p><b>林声</b>中国击剑运动员</p>
                                        </div>
                                    </Link>
                                    }
                                    {this.state.interviewPage === 3 &&
                                    <Link to="/interview/4">
                                        <div>
                                            <img src={require('./../../pic/interview32_s.jpg')} alt=""></img>
                                            <p><b>孙伟</b>中国击剑队男子佩剑运动员</p>
                                        </div>
                                    </Link>
                                    }
                                </div>
                            }
                            {this.props.match.params.id == 2 &&           
                                <div className="other_interview">
                                    {this.state.interviewPage === 1 &&
                                    <Link to="/interview/1">
                                        <div>
                                            <img src={require('./../../pic/interview23_s.jpg')} alt=""></img>
                                            <p><b>刘倩</b>国家击剑队健将级运动员</p>
                                        </div>
                                    </Link>
                                    }
                                    {this.state.interviewPage === 2 &&
                                    <Link to="/interview/3">
                                        <div>
                                            <img src={require('./../../pic/interview01_s.jpg')} alt=""></img>
                                            <p><b>林声</b>中国击剑运动员</p>
                                        </div>
                                    </Link>
                                    }
                                    {this.state.interviewPage === 3 &&
                                    <Link to="/interview/4">
                                        <div>
                                            <img src={require('./../../pic/interview32_s.jpg')} alt=""></img>
                                            <p><b>孙伟</b>中国击剑队男子佩剑运动员</p>
                                        </div>
                                    </Link>
                                    }
                                </div>
                            }
                            {this.props.match.params.id == 3 &&           
                                <div className="other_interview">
                                    {this.state.interviewPage === 1 &&
                                    <Link to="/interview/1">
                                        <div>
                                            <img src={require('./../../pic/interview23_s.jpg')} alt=""></img>
                                            <p><b>刘倩</b>国家击剑队健将级运动员</p>
                                        </div>
                                    </Link>
                                    }
                                    {this.state.interviewPage === 2 &&
                                    <Link to="/interview/2">
                                        <div>
                                            <img src={require('./../../pic/interview11_s.jpg')} alt=""></img>
                                            <p><b>谭雪</b>女子击剑运动员</p>
                                        </div>
                                    </Link>
                                    }
                                    {this.state.interviewPage === 3 &&
                                    <Link to="/interview/4">
                                        <div>
                                            <img src={require('./../../pic/interview32_s.jpg')} alt=""></img>
                                            <p><b>孙伟</b>中国击剑队男子佩剑运动员</p>
                                        </div>
                                    </Link>
                                    }
                                </div>
                            }
                            {this.props.match.params.id == 4 &&           
                                <div className="other_interview">
                                    {this.state.interviewPage === 1 &&
                                    <Link to="/interview/1">
                                        <div>
                                            <img src={require('./../../pic/interview23_s.jpg')} alt=""></img>
                                            <p><b>刘倩</b>国家击剑队健将级运动员</p>
                                        </div>
                                    </Link>
                                    }
                                    {this.state.interviewPage === 2 &&
                                    <Link to="/interview/2">
                                        <div>
                                            <img src={require('./../../pic/interview11_s.jpg')} alt=""></img>
                                            <p><b>谭雪</b>女子击剑运动员</p>
                                        </div>
                                    </Link>
                                    }
                                    {this.state.interviewPage === 3 &&
                                    <Link to="/interview/3">
                                        <div>
                                            <img src={require('./../../pic/interview01_s.jpg')} alt=""></img>
                                            <p><b>林声</b>中国击剑运动员</p>
                                        </div>
                                    </Link>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div>
                        {this.props.match.params.id == 1 &&
                            <div className="right_inner">
                                <p>由贵族走向平民，击剑有助塑造孩子的身形和品格？ </p>
                                <p>里约奥运会今天闭幕，这届奥运会上国内观众的心态已经在发生变化，一些少数人参与的职业运动走向大众层面，变得更接地气。击剑，在我们的印象中是一项欧洲的贵族运动，但近些年来，身边朋友的孩子练击剑的渐渐多起来。据说击剑是对身体损伤比较少的运动，凭借击剑特长，一些孩子已经撬开了国内外名校的门。</p>
                                <img src={require('./../../pic/interview21.jpg')} alt=""></img>
                                <p>击剑真的适合大多数孩子么？击剑这项运动的安全性如何？带着家长们关心的问题，小营采访了原国家击剑队健将级运动员刘倩，她从一个专业击剑运动员、教练员的角度为我们详细阐述击剑运动和孩子的关系。</p>
                                <img src={require('./../../pic/interview22.jpg')} alt=""></img>
                                <p>初见到刘倩，她礼貌地和我们打招呼，举手投足之间都有着优雅自然的姿态，流露出独特的气质，这和她长期练习击剑有着千丝万缕的联系。练习击剑不仅能锻炼体能，还能培养优雅的气质，沉着冷静的心理素质。这也是为什么中国击剑队里约奥运一亮相，匀称的身材（特别是大长腿）及高雅气质便吸引国内不少粉丝。</p>
                                <p>刘倩初二开始学击剑，练了14年。她与击剑结缘，是奥运会做了她的启蒙。刘倩回忆当时正是2000年悉尼奥运会，坐在电视机前的她被李娜、杨劭崎和梁琴参与的女子团体重剑比赛吸引了。看完之后特别激动，一门心思想着练习击剑。当时丹东体校正好也有击剑队，便开始学习击剑，并且做了李娜的启蒙教练李维仁的关门弟子。</p>
                                <img src={require('./../../pic/interview23.jpg')} alt=""></img>
                                <p>最初在丹东体校学习的时候，她还只是走读的形式，白天上文化课，晚上练习击剑。或许是兴趣、天赋、刻苦练习使然，在体校练了不到一年，就在辽宁省的击剑比赛中获得了冠军，随后便进入了辽宁击剑专业队。进入辽宁专业队后，训练强度加大，上午学习文化课后，下午和晚上的时间都在训练房度过。2004年进入国家队后，取得了全国冠军总决赛个人季军、团体冠军。目前，刘倩已从国家队退役，专职从事青少年击剑培训工作。</p>
                                <p>以下为采访实录：</p>
                                <p>问：中国的孩子什么时候开始练习击剑的？</p>
                                <p>答：有着“格斗中的芭蕾”的击剑运动起源于中世纪的欧洲，与马术、下棋、吟诗、投枪一起被列为骑士的其中高尚运动。后来法国做了击剑用的面罩护具使得击剑运动得以大规模普及，法国普通青少年都或深或浅地学习过击。击剑运动正式引入中国则是1955年，前苏联专家赫鲁晓娃在北京体育学院（现北京体育大学）开设击剑专修课，击剑才在中国发展起来。近些年来，中国孩子学习击剑的越来越多，像北、上、广、深一线城市，击剑已经进入了学校，有的学校甚至成立了“击剑队”。一些孩子凭借击剑特长撬开了世界名校的大门。</p>
                                <p>问：击剑主要分成几种？</p>
                                <p>答：击剑剑种分为花剑、佩剑和重剑三类，花剑：由剑柄、剑身和护手盘组成。全长不超过110厘米,重量不超过500克。剑身为钢制,横截面为长方形。花剑主要以刺为主,有效部位是躯干,有裁判的优先权。佩剑：由剑柄、剑身和护手盘组成。全长不超过105厘米,重量不超过500克。剑身为钢制,有刃与背,横截面为牙形。佩剑主要以劈（刺）为主,有效部位是上身,有裁判优先权。重剑：由剑柄、剑身和护手盘组成。全长不超过110厘米,重量不超过750克。剑身为钢制,横截面为三棱形。重剑主要以刺为主,有效部位是全身,由于没有裁判优先权，刺中就能得分。</p>
                                <p>问：学习击剑对孩子的成长有什么好处？</p>
                                <p>答：击剑作为奥运会唯一的持械项目，不仅是体力的较量，更是斗智斗勇，心理素质的较量。练习击剑不但能使孩子拥有良好的体能、优雅的身姿，还能打造出坚韧的意志、勇敢自信的品格和独立冷静的思维能力、提升专注力。特别是对有驼背苗头的孩子，练习击剑能够对青少年进行有效的身姿和脊柱矫正。而且孩子在持剑、练习击剑时，容易产生英雄情结，有利于增强孩子的自信心。</p>
                                <p>问：起源于欧洲的击剑适合中国孩子学吗？适合几岁的孩子学习？</p>
                                <p>答：用简单的例子来做个比方，大家都知道欧洲人用餐时都是用刀叉，而我们用筷子，对筷子的掌握很灵活。同样，在学习击剑时，中国孩子更易入门。当然，由于体质的差异，中国孩子更适合练习爆发力和细巧的动作，力量的抗衡转换为技巧的抗衡。比如欧美的运动员一般控剑范围在1米左右，我们可以控制在半米，而在比赛打到最后都是在比心理素质。一般五岁半的孩子就适合学习，身高超过1.2m的身体健壮的男孩女孩都可参与。身体瘦小的孩子不建议学习。</p>
                                <p>问：击剑的课程如何安排，如何考核？</p>
                                <p>答：对于初练击剑的孩子，首先让孩子入门，学习击剑的基本知识和礼仪，激发孩子的好奇心，从而形成学习的兴趣；随后根据孩子的身体、心理素质等特点，教练帮助孩子选择适合自己的剑种；随着练习的深入孩子们将进入实战对抗，将有机会在俱乐部内打一些比赛进而参加全国性的比赛。各个俱乐部教练水平不一，孩子的进步程度也不一样。如果孩子在参加北京市或者全国性的比赛中获得不错的成绩，将对孩子的升学有帮助，像人大附中、北京四中等都有击剑特长生的招生名额。而且像清华等高校也有招收高水平击剑运动员的资格。</p>
                                <p>问：击剑运动安全吗？</p>
                                <p>答：击剑作为成熟的体育运动，安全上没有问题。而且，一般给刚入门的苗苗班的孩子（5岁半左右）使用的是特制剑即泡沫剑、塑料剑或者软剑而且训练时需要穿上厚的皮马甲并佩戴防护装备。苗苗班结束之后孩子们根据自己的兴趣选择剑种，这时候孩子使用的是弹簧钢材质的真剑。与成人使用的剑不同的是，孩子们使用的剑更短更轻一些，比如花剑和佩剑长90厘米，重350克。另外击剑运动在训练中相比于其他体育运动来说损伤小，而且击剑动作中的弹跳伸展有利于帮助孩子塑形和促进身高发育。</p>
                                <p>问：现在孩子们在练习击剑时会面临哪些问题？</p>
                                <p>答：根据我的多年的教练经验来看，现在孩子普遍吃苦精神差一些，抗挫折能力弱。但是合作精神都还不错，刚开始有一些孩子不合群，不过半年后也会融入团体。另外，击剑属于无氧运动，需要有很强的爆发力，消耗更多的能量，也会有一些孩子为了减肥而来学习的。 </p>
                            </div>
                        }
                        {this.props.match.params.id == 2 &&
                            <div className="right_inner">
                                <p>击剑世界冠军谭雪：离开赛场，依然执剑前行！</p>
                                <p>谭雪，前中国国家队女子佩剑运动员。1998年进入天津击剑队成为一名击剑运动员到2013年退役，十五年的运动员生涯里，谭雪一次次站在世界击剑的赛台上，以其高超的击剑技术和不服输的运动精神为国家赢得了一个又一个荣誉。</p>
                                <img src={require('./../../pic/interview11.jpg')} alt=""></img>
                                <p>2002年，里斯本世界锦标赛女子佩剑比赛冠军；2004年，雅典奥运会女子佩剑个人比赛亚军；2006年，多哈亚运会女子佩剑比赛冠军...赛台上，谭雪是手持佩剑迎风而战的“击剑皇后”。台下，她也依旧不改对击剑的热爱。退役后，谭雪回到家乡天津塘沽创办了自己的击剑培训学校“世冠击剑”，以另一种身份开启了一段新的击剑生涯。</p>
                                <p>Q：您作为女子佩剑世界冠军，我们对您的求学、训练很感兴趣，请介绍一下当年您的击剑求学之路？</p>
                                <p>其实我以前是练田径的，当时我在田径队的成绩也是非常不错，在天津市成绩也是第一第二的，但是当时没有我成绩好的那些运动员全输送到了市队，我就有点不服气：没我成绩好怎么都去了市队呢？这个时候可能也是机缘巧合，天津市要成立女子佩剑组，然后就有教练到塘沽四中来挑选队员。我当时没有问什么项目，就直接问是不是可以去市队，然后教练回答我说是的，当时我一点没犹豫就说我去。后来我们教练问我知道是什么项目吗？我说不知道，他说击剑你听说过吗？我说我只知道基础建设，他说这完全是两回事。后来他又问我你知道佐罗吗？佐罗我是知道的，然后我才对击剑有了一个初步的认识。没过多长时间就去天津市集训了，刚集训的时候，一进去就看到两个特别高的男生穿了一身白衣服各自还拿了一把剑在那对练，那时候觉得非常帅，当时就被吸引了，之后慢慢地就步入了击剑的道路。</p>
                                <img src={require('./../../pic/interview12.jpg')} alt=""></img>
                                <p>Q：作为全国冠军、亚运会冠军、世锦赛冠军、奥运会亚军，您获得的奖牌不计其数，在众多比赛中，哪一场比赛让您最难忘，并时常想起？</p>
                                <p>我最难忘的一场比赛是1999年的全国击剑锦标赛，因为那是我1999年1月到天津市体工大队练习了三个月以后参加的第一场全国比赛。以前练田径，如果能参加到全国比赛，就是一个很高级别的比赛了。可当时没练几个月就有机会去参加全国的比赛，所以对这个比赛特别憧憬。而且，当时击剑还是一个新兴项目，我们算是中国的第一批击剑运动员。比赛的时候其他剑种的运动员也都在着看我们女子佩剑组，所以第一次比赛对我来说还是挺难忘的，当时获得了第三名。</p>
                                <p>Q：击剑运动是一项古老的运动，早在中世纪的欧洲，击剑与骑马、游泳、打猎、下棋、吟诗、投枪一起被列为骑士的七种高尚运动。相对于欧洲较早开展击剑运动，中国击剑运动只有六十多年历史。请介绍一下中国击剑目前在世界的地位，尤其是青少年击剑的发展！</p>
                                <p>击剑在我们国家起步是比较晚的，最开始法国、意大利、俄罗斯等国家在击剑项目上是占据优势的，所以一开始我们也是以他们为主要的对手，虽然刚开始和他们不在一个档次上，但是通过长时间的积累、训练，也慢慢拉近了我们之间的差距。现在每届奥运会的击剑项目，我们国家都会有金牌的成绩出现。现在，击剑在我们国家也在慢慢的发展，从我们建立击剑培训学校以来，每年都会参加击剑的业余联赛，从第一年单战比赛一个剑种200多人，到第二年两个剑种500多人，再到第三年一个剑种800多人，而现在单战比赛可以达到4000多人，这个发展是非常迅速、非常快的，尤其是在北京。我觉得青少年击剑的前景是非常大的。</p>
                                <img src={require('./../../pic/interview13.jpg')} alt=""></img>
                                <p>Q：作为世界冠军，您退役后没有选择像大多数知名运动那样去从政，而是选择回到家乡创办世冠击剑，可以介绍一下您当时创办世冠击剑的初衷吗？</p>
                                <p>退役了以后感觉自己离奥运冠军的梦想只差一点点，而且当时对击剑项目的感情也是非常深厚的，退役以后就回到了天津队，然后发现天津击剑项目青黄不接的状态非常严重，滨海新区塘沽这个地方培养了我，我觉得在这边有很多潜在的人才，包括我自己也是从基层慢慢出来的，所以我希望通过我的努力能从基层中选出一些优秀的击剑人才，所以就回来创办了一家击剑培训学校。</p>
                                <p>Q：孩子在哪个年龄段练击剑比较合适？世冠击剑的教育理念是什么？</p>
                                <p>根据孩子的接受能力，有从小学一年级开始的，也有从幼儿园大班开始的，其实这个年龄段就是在打基础，培养孩子的兴趣。一般来说五到七岁是黄金年龄。我们世冠击剑是以培养冠军为出发点，世界冠军做教练，我们用培养冠军的高标准、严要求去培养孩子，让孩子从小就拥有高起点，学习到最先进的击剑技术，为他们以后成为冠军打下扎实的基础。</p>
                                <img src={require('./../../pic/interview14.jpg')} alt=""></img>
                            </div>
                        }
                        {this.props.match.params.id == 3 &&
                            <div className="right_inner">
                                <p>专访林声：银牌是新的开始 原本个人赛只想找感觉</p>
                                <p>北京时间7月19日凌晨，林声在2019年布达佩斯击剑世锦赛中拿到了女子重剑个人赛银牌，这是中国队在本届世锦赛中拿到的第一枚奖牌，也是林声迄今为止职业生涯最佳战绩。</p>
                                <img src={require('./../../pic/interview01.jpg')} alt=""></img>
                                <p>赛后，林声接受了新浪体育的专访。在她看来，这个银牌只是新的开始，在个人赛决赛结束的那一刻，她已经将目光投向了之后的团体赛。</p>
                                <p>25岁的林声之前在队中并非头号选手。作为新加坡青奥会冠军，林声直到2018年才第一次参加世锦赛。在新的奥运会周期中，两位奥运会冠军孙玉洁与许安琪都为自己的职业生涯做了不同的打算，孙玉洁决定退役，以另一种身份推广击剑；许安琪则是在前不久又回到了队中，这次也和队友一起来到了布达佩斯参赛。　　在新赛季中，孙一文曾拿到过一站世界杯赛的个人赛冠军，朱明叶在前一段时间里表现稳定。相比之下，林声在之前个人赛的战绩并不算突出，她将自己定位为团体赛选手，希望在团体赛中能为队伍出力。</p>
                                <p>这次比赛前，林声对个人赛并没有太多的期待，她对新浪体育说道：“因为之前亚锦赛时我打完个人赛是膝盖韧带受伤了，也影响到了我在团体赛中的表现。在到匈牙利前都没有练专项，这次比赛我就是希望自己不能受伤，打个人赛的时候我的想法就是利用这次个人赛找感觉，然后力争团体有好的表现。”</p>
                                <p>也许正是这种心态帮助她在场上稳扎稳打——半决赛她在第三节时比分处于落后，但她心态稳定，将比分扳成14比14，之后又在加时赛中把握住机会，以15比14逆转取胜乌克兰选手克尤特斯卡，职业生涯第一次晋级世锦赛个人赛半决赛。在决赛中，面对33岁的老将、巴西选手摩尔豪森，林声也是在比分落后的情况下打得很顽强，一度将比分改写为12比12。</p>
                                <p>然而她在决赛中的运气不如半决赛，同样的一剑决胜负的激烈对决，林声没能复制半决赛时的一幕。在对手拿到制胜分、激情庆祝时，站在不远处的林声神情落寞。回顾这场比赛时，她说道：“我感觉自己在决赛中表现得不错，但可以做得更好。我的对手整体状态很好，而且比赛刚开始时对我进攻的限制针对性很强，我一直在改变不同的进攻手段。在12比12时，我已经想好了战术，像前面那样紧逼，把铺垫做到位，打直接进攻。但对手突然做了进攻，我其实预想到了，但本能反应做了一个防守，对手把握住机会，得到了1分。”</p>
                                <p>她对新浪体育透露，在个人赛结束的第一时间，她就想到了之后的团体赛。这个银牌对她而言是一个新的开始，也是实力的证明，“这次是我第二次参加世锦赛，在2018年我记得自己没有进32强，那时信心有所欠缺，我很感谢教练，他不停地告诉我我很强，这个银牌感觉只是开始，我要更努力，我们的目标是东京奥运会。” </p>
                            </div>
                        }
                        {this.props.match.params.id == 4 &&
                            <div className="right_inner">
                                <p>专访孙伟：希望大家认识击剑魅力 拥有健康体魄</p>
                                <p>阳光帅气的外型，修长健美的身材，谦逊亲和的态度，这是击剑运动员孙伟给记者的第一印象，如今，他不仅仅是一名运动员，数次出现在电视节目中的他，也成为了一名优质偶像。</p>
                                <p>社交媒体上，他有超过100万的粉丝，而这次亚运会，孙伟作为火炬手，出现在大家面前。在亚运会的举办城市印尼首都雅加达，孙伟接受了搜狐前方记者的专访，和我们一起畅聊他15年的击剑人生，以及他一直在做的，对击剑这项运动的大力推广。</p>
                                <img src={require('./../../pic/interview31.jpeg')} alt=""></img>
                                <p>“以前看火炬传递，都是人家在跑，没想到这次亚运会，我的梦想实现了，真的非常开心。”孙伟对搜狐记者说，“以火炬手的身份参加亚运会，意义是不一样，上次亚运会我是运动员的身份，一个场内，一个场外，我想，去传递这种积极拼搏的精神是很有意义的。”聊起上届亚运会，孙杨伟打开了话匣子，他说，那真的就好像是在昨天发生一样，所有场景都历历在目。</p>
                                <p>“上届亚运会是我第一次参加，对我来说有收获也有小小的遗憾，对于年轻队员来说，突破是获得了一枚奖牌，遗憾是团体赛一剑之差，没能进入决赛。半决赛对伊朗，44平，谁再得一分就可以取胜，我们都把头背过去不敢看，后来听见教练的呐喊，我们都上去疯狂庆祝。但是经过录像回看，裁判进行了改判，我们输掉了比赛。那时的心情，真是从天堂到地狱，非常遗憾。但是这届亚运会，我祝福击剑队，取得好成绩！”虽然这届亚运会孙伟并不会上场比赛，但是对击剑队他还是很有感情，并且信心十足。“这届有很多我的队友和师弟参加，他们的状态越来越好，我期待他们争金夺银，中国击剑队有很多夺金点。”孙伟说。当然，亚运会的项目不只是击剑，孙伟说，其他项目当然自己也会去关注。“我主要最关注击剑，其他的当然也会看，比如我的好朋友孙杨也会来比赛，还有就是电竞第一次进入亚运会，让外界更好的了解电竞。其实所有的项目都传递着体育的精神，我也会关注中国代表团的表现。”</p>
                                <img src={require('./../../pic/interview32.jpeg')} alt=""></img>
                                <p>并且，孙伟还像我们透露了一个小秘密。“昨天刚下飞机，就吃了一把狗粮，我的好朋友张培萌宣布了恋情，他的女友我也认识，祝福他们。在七夕这天我也在想，自己的春天什么时候能来？”原来，高大帅气的孙伟还没有女朋友，居然也属于单身狗的群体。除了运动员的身份，孙伟的另外一个身份是击剑运动的推广者，他已经登上过《快乐大本营》和《一站到底》等一线节目。俊朗帅气的外型让他引人关注，里约奥运会他曾经一天暴涨几十万粉丝，而在综艺节目中的亮相，更加增加了他的曝光度。</p>
                                <p>“以前可能了解运动员的机会很少，现在很有多方式，现在我们来宣传我们从事的运动，我认为是应该要做的，去大学演讲，去夏令营教小孩子击剑，让更多人参与进来，我是十分高兴和开心的。”孙伟认为，自己这样的一个身份可以很好的推广击剑，让更多人知道并了解这项运动，最重要的是有一个健康的生活方式和身体素质。</p>
                                <p>“最主要的是让大家认识到击剑的魅力，比如是提高大家的专注力，让大家有更健康的体魄，性格上的培养，对骑士精神的理解。”“我从事击剑已经15年了，击剑代表国家队去世界各地比赛，了解了各国的文化，结识了很多朋友，同时我对击剑的文化和魅力也有更深的了解，这项运动让我的生活更加丰富。我个人就喜欢挑战新鲜的事物，跨界之后我对这项运动有了新的认识。”孙伟说。</p>
                                <p>现在，孙伟有了新的挑战，他将踏足影视圈。“最近接了一部戏，击剑题材的，叫《拜托了，师兄》，我很荣幸在里面担任击剑技术指导，也希望更多人通过这部剧爱上击剑。”采访最后，孙伟透露了自己的美好愿景，他说，自己的粉丝越来越多，自己的使命感也是越来越大。“我需要做的是，比如能告诉他们按时吃早餐，利用碎片时间运动，有健康的身体，哪怕一点点都是很好的。”他说。 </p>
                            </div>
                        }
                    </div>
                </div>
            </main>
        )
    }
};